import React from 'react';

/**
 * TextField component - handles text and email input types
 */
function TextField({ field, index, value, onChange, formId }) {
    const fieldId = `${formId}_${field.name}_${index}`;

    return (
        <input
            type={field.type}
            id={fieldId}
            value={value || ''}
            onChange={(e) => onChange(index, e.target.value)}
            className="w-full px-3 py-2 bg-surface-2 text-content border border-line rounded-md focus:outline-none focus:ring-2 focus:ring-amber placeholder:text-content-muted"
            placeholder={field.placeholder || ''}
        />
    );
}

export default TextField;
